import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { TipoPreciosService } from 'src/app/services/empresa/tipo-precios.service';

@Component({
    selector: 'app-ordenes-fisicas-tipo-precios',
    templateUrl: './ordenes-fisicas-tipo-precios.component.html',
    styleUrls: ['./ordenes-fisicas-tipo-precios.component.scss'],
    standalone: false
})
export class OrdenesFisicasTipoPreciosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public tipoPrecios: any[] = [];
  public cargando = false;
  public guardando = false;

  public nuevoTipo = '';
  public editarTipo = '';
  public idTipo = '';

  constructor(
    private tipoPreciosService: TipoPreciosService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[2, 'desc']],
      language: LanguageApp.spanish_datatables
    };

    this.obtenerTipoPrecios();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  obtenerTipoPrecios() {
    this.cargando = true;

    this.tipoPreciosService.listarTipoPrecios().subscribe({
      next: (resp: any) => {
        const data = Array.isArray(resp) ? resp : resp?.rows ?? resp?.data ?? [];

        this.tipoPrecios = data;
        this.cargando = false;

        if (!this.isDtInitialized) {
          this.dtTrigger.next(null);
          this.isDtInitialized = true;
          return;
        }

        this.rerender();
      },
      error: () => {
        this.cargando = false;
        this.toastr.error('No se pudo cargar la lista de tipos de precio.');
      }
    });
  }

  abrirModalAgregar(modal: any) {
    this.nuevoTipo = '';
    this.modalService.open(modal, {
      centered: true
    });
  }

  abrirModalEditar(modal: any, tipoPrecio: any) {
    this.idTipo = String(tipoPrecio.COD_TIPPREC ?? '');
    this.editarTipo = tipoPrecio.DES_TIPPREC ?? '';
    this.modalService.open(modal, {
      centered: true
    });
  }

  crearTipoPrecio() {
    const descripcion = this.nuevoTipo.trim();

    if (!descripcion) {
      this.toastr.error('Ingrese un tipo de precio.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.guardando = true;
    this.tipoPreciosService.crearTipoPrecio(descripcion).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Tipo de precio guardado correctamente.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.obtenerTipoPrecios();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo guardar el tipo de precio.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  actualizarTipoPrecio() {
    const descripcion = this.editarTipo.trim();

    if (!descripcion) {
      this.toastr.error('Ingrese un tipo de precio.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.guardando = true;
    this.tipoPreciosService.editarTipoPrecio(this.idTipo, descripcion).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Tipo de precio actualizado correctamente.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.obtenerTipoPrecios();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo actualizar el tipo de precio.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  eliminarTipoPrecio(tipoPrecio: any) {
    const idTipoPrecio = String(tipoPrecio.COD_TIPPREC ?? '');
    const descripcion = tipoPrecio.DES_TIPPREC ?? 'este registro';

    Swal.fire({
      icon: 'warning',
      title: '¿Eliminar tipo de blocks?',
      text: `Se eliminará ${descripcion}.`,
      showCancelButton: true,
      confirmButtonColor: '#6259ca',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.tipoPreciosService.eliminarTipoPrecio(idTipoPrecio).subscribe({
        next: () => {
          this.toastr.success('Tipo de block eliminado correctamente.', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.obtenerTipoPrecios();
        },
        error: () => {
          this.toastr.error('No se pudo eliminar el tipo de block.', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
        }
      });
    });
  }

  private rerender(): void {
    if (!this.dtElement) {
      return;
    }

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: {
      first: 'Primero',
      previous: 'Ant',
      next: 'Sig',
      last: 'Último'
    },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
